import { useCallback } from 'react';

import { useNavigationStack } from '../../../../context/NavigationStackContext';
import { useRestrictions } from '../../../../hooks/use-restrictions';
import { useLazyGetCreatedByUserExercises } from '../../../../redux/api/exercisesAPI';
import { Paths } from '../../../../shared/paths';
import { useExerciseListLazyTab } from '../hooks/useExerciseListLazyTab';

interface IUseMyExercisesPageParams {
  setPlanDialogOpen: (open: boolean) => void;
}

export function useMyExercisesPage({
  setPlanDialogOpen,
}: IUseMyExercisesPageParams) {
  const { navigate } = useNavigationStack();
  const {
    exercises,
    isLoading,
    error,
    hasData,
    refetch,
    refetchAll,
    footerRef,
    handleQueryChange,
    handleRetry,
    isFetching,
  } = useExerciseListLazyTab(useLazyGetCreatedByUserExercises, 'my');
  const { isShowAddButton, isShowPlanDialogOnClick } = useRestrictions();

  const addNewExerciseClicked = useCallback(() => {
    if (isShowPlanDialogOnClick?.exercises) {
      setPlanDialogOpen(true);
    } else {
      navigate(Paths.exercises.toNew());
    }
  }, [navigate, isShowPlanDialogOnClick?.exercises, setPlanDialogOpen]);

  return {
    exercises,
    isLoading,
    error,
    hasData,
    addNewExerciseClicked: isShowAddButton?.exercises
      ? addNewExerciseClicked
      : undefined,
    refetch,
    refetchAll,
    footerRef,
    handleQueryChange,
    handleRetry,
    isFetching,
  };
}
